export default {
  'AvgSentiment.title': 'Average sentiment (CSAT)',
  'AvgSentiment.good': 'good',
  'AvgSentiment.normal': 'normal',
  'AvgSentiment.bad': 'bad',
  'AvgSentiment.tooltipText':
    "Sentiment is people's opinions or feelings about your products. The average sentiment is calculated based on the sentiment of all products in your account",
}
